module.exports = __webpack_public_path__ + "media/brands/nysa-7a45ed32.png";